/* js/filter.js */

;(function($, window, document) {
    
    /**
     * Store scroll position for and set it after reload
     *
     * @return {boolean} [loacalStorage is available]
     */
    $.fn.scrollPosReaload = function(){
        if (localStorage) {
            var posReader = localStorage["posStorage"];
            if (posReader) {
                $(window).scrollTop(posReader);
                localStorage.removeItem("posStorage");
            }
            $(this).click(function(e) {
                localStorage["posStorage"] = $(window).scrollTop();
            });

            return true;
        }

        return false;
    }

    $(window).on('load', function() {
        $(".ce_metamodels_frontendfilter").find("input , select").scrollPosReaload();
    });
    
})(jQuery, window, document);